<!--
    Replaces <mat-progress-bar> with a CSS-only equivalent.
    @angular/material 14's mat-progress-bar emits SVG with `url(#mat-progress-bar-N)`
    references whose resolution interacts badly with <base href="/"> + client-side
    routing on some Chrome versions — the browser self-fetches the current page URL
    as the SVG source, surfacing as `GET /<route>  ERR_ABORTED 404`. Replacing the
    component with a plain CSS bar removes the SVG mask path entirely. Fixed in
    Material v15+; this is the workaround until the framework upgrade lands.
-->
<ng-container *ngIf="show">
    <div class="fuse-loading-bar-track" [class.indeterminate]="mode === 'indeterminate'">
        <div
            class="fuse-loading-bar-fill"
            [style.width.%]="mode === 'determinate' ? progress : null"
        ></div>
    </div>
</ng-container>
